import {
	Bluetooth as BluetoothIcon,
	ContactlessOutlined as ContactlessOutlinedIcon,
	CloudOutlined as CloudOutlinedIcon,
	HelpOutline as HelpOutlineIcon,
	SdCardOutlined as SdCardOutlinedIcon,
	AccessAlarm as AccessAlarmIcon,
	ScheduleOutlined,
	LinkOutlined,
} from '@mui/icons-material';
import { SvgIcon, SvgIconProps } from '@mui/material';

import AccessActionTypeEnum from '../../enums/accessActionTypeEnum';

interface AccessActionTypeIconProps extends SvgIconProps {
	actionType: AccessActionTypeEnum;
}

const AccessActionTypeIcon = ({ actionType, ...iconProps }: AccessActionTypeIconProps) => {
	const getIcon = () => {
		switch (actionType) {
			case AccessActionTypeEnum.Bluetooth:
				return BluetoothIcon;
			case AccessActionTypeEnum.Memory:
				return SdCardOutlinedIcon;
			case AccessActionTypeEnum.Rfid:
				return ContactlessOutlinedIcon;
			case AccessActionTypeEnum.Server:
				return CloudOutlinedIcon;
			case AccessActionTypeEnum.Schedule:
				return AccessAlarmIcon;
			case AccessActionTypeEnum.ServerScheduled:
				return ScheduleOutlined;
			case AccessActionTypeEnum.ServerTriggered:
				return LinkOutlined;
			default:
				return HelpOutlineIcon;
		}
	};

	return <SvgIcon {...iconProps} component={getIcon()} />;
};

export default AccessActionTypeIcon;
